var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Create Job")]),
    _vm._v(" "),
    _c("div", { staticClass: "l-bg-white" }, [
      _c(
        "form",
        {
          attrs: { autocomplete: "no" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            },
            keydown: function($event) {
              _vm.clearError($event)
            }
          }
        },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Company")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.job.company_id,
                        expression: "job.company_id"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.job,
                            "company_id",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.setCompany
                      ]
                    }
                  },
                  _vm._l(_vm.companies, function(company) {
                    return _c(
                      "option",
                      { key: company.id, domProps: { value: company.id } },
                      [_vm._v(_vm._s(company.name))]
                    )
                  })
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "company_id" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Carrier")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.job.carrier_id,
                        expression: "job.carrier_id"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.job,
                          "carrier_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.carriers, function(carrier) {
                    return _c(
                      "option",
                      { key: carrier.id, domProps: { value: carrier.id } },
                      [_vm._v(_vm._s(carrier.name))]
                    )
                  })
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "company_id" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Move size")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.job.move_size_id,
                        expression: "job.move_size_id"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.job,
                          "move_size_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.move_sizes, function(move_size) {
                    return _c(
                      "option",
                      { key: move_size.id, domProps: { value: move_size.id } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(move_size.name) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "move_size_id" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Arrival window")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.job.arrival_window_id,
                        expression: "job.arrival_window_id"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.job,
                          "arrival_window_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.arrival_windows, function(arrival_window) {
                    return _c(
                      "option",
                      {
                        key: arrival_window.id,
                        domProps: { value: arrival_window.id }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(arrival_window.name) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "arrival_window_id" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Source")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.job.source_id,
                        expression: "job.source_id"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.job,
                          "source_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.sources, function(source) {
                    return _c(
                      "option",
                      { key: source.id, domProps: { value: source.id } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(source.name) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "source" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Movers")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.movers,
                      expression: "job.movers"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.job.movers },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job, "movers", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "movers" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Trucks")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.trucks,
                      expression: "job.trucks"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.job.trucks },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job, "trucks", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "trucks" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Min hours")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.minimum_hours,
                      expression: "job.minimum_hours"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.job.minimum_hours },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job, "minimum_hours", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "minimum_hours" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Price per hour")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.price_per_hour,
                      expression: "job.price_per_hour"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.job.price_per_hour },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job, "price_per_hour", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "price_per_hour" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Deposit")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.deposit_value,
                      expression: "job.deposit_value"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.job.deposit_value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job, "deposit_value", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "deposit_value" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Estimated hours")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.estimated_hours,
                      expression: "job.estimated_hours"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.job.estimated_hours },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job, "estimated_hours", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "estimated_hours" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Price in $")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.price,
                      expression: "job.price"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.job.price },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job, "price", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "price" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Customer name")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.job.customer,
                        expression: "job.customer"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.job,
                          "customer",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.customers, function(customer) {
                    return _c(
                      "option",
                      { key: customer.id, domProps: { value: customer } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(customer.first_name) +
                            " " +
                            _vm._s(customer.last_name) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "customer_id" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Customer email")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.customer.email,
                      expression: "job.customer.email"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.job.customer.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job.customer, "email", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "email" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Customer phone")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.job.customer.phone,
                      expression: "job.customer.phone"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.job.customer.phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.job.customer, "phone", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "phone" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("label", [_vm._v("Pickup date")]),
                _vm._v(" "),
                _c("datepicker", {
                  staticClass: "form-control",
                  attrs: {
                    name: "move_date",
                    placeholder: "Select Date",
                    format: _vm.dateFormatter
                  },
                  model: {
                    value: _vm.job.move_date,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "move_date", $$v)
                    },
                    expression: "job.move_date"
                  }
                }),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "move_date" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.job.addresses, function(address, index) {
            return [
              _c("div", { key: address.id, staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(address.type === 1 ? "Pickup" : "Delivery") +
                          " address"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: address.full_address,
                          expression: "address.full_address"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: address.full_address },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              address,
                              "full_address",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.getAddressData(address.full_address, index)
                          }
                        ],
                        keydown: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "down", 40, $event.key, [
                              "Down",
                              "ArrowDown"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          $event.target.nextElementSibling.firstChild.focus()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.showDropdown[index] === true && _vm.addresses[index]
                      ? _c(
                          "div",
                          {
                            staticClass: "dropdown-menu show",
                            attrs: { "aria-labelledby": "dropdownMenu2" }
                          },
                          _vm._l(_vm.addresses[index], function(addressInner) {
                            return _c(
                              "button",
                              {
                                key: addressInner.id,
                                staticClass: "dropdown-item",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.setAddress(addressInner, index)
                                  },
                                  keydown: [
                                    function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "down",
                                          40,
                                          $event.key,
                                          ["Down", "ArrowDown"]
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      $event.target.nextElementSibling.focus()
                                    },
                                    function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "up",
                                          38,
                                          $event.key,
                                          ["Up", "ArrowUp"]
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.target.previousElementSibling.focus()
                                    }
                                  ]
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(addressInner.full_address) +
                                    "\n              "
                                )
                              ]
                            )
                          })
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: {
                        errors: _vm.errors,
                        field: "addresses." + index + ".postal_code"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("label", [_vm._v("Floor")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: address.floor,
                        expression: "address.floor"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: address.floor },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(address, "floor", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("label", [_vm._v("Apartment")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: address.apartment,
                        expression: "address.apartment"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: address.apartment },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(address, "apartment", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { key: address.id, staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col-4" }, [
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            _vm.removeAddress(index)
                          }
                        }
                      },
                      [_vm._v("X Remove address")]
                    )
                  ])
                ])
              ])
            ]
          }),
          _vm._v(" "),
          _c("p", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.addPickupAddress }
              },
              [_vm._v("+ Add pickup address")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.addDeliveryAddress }
              },
              [_vm._v("+ Add delivery address")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col" }, [
              _c("button", { staticClass: "btn btn-primary float-right" }, [
                _vm._v("Save")
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-danger float-left",
                  on: {
                    click: function($event) {
                      _vm.remove({
                        carrierId: _vm.carrier,
                        truckId: _vm.truck.id
                      })
                    }
                  }
                },
                [_vm._v("\n            Delete\n          ")]
              )
            ])
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Move info")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Job price")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Contact information")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Addresses")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16c3850b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16c3850b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobsCreate.vue
// module id = null
// module chunks = 